import React from "react";
import PropTypes from "prop-types";

import * as Theme from "../../../../App/Theme";

import HelpIcon from "../../../../Img/DM/Help 32 n p.png";

import GBStdChart from "../../../../Library/Charts/GBStdChart";
import TComboBox from "../../../../Library/ComboBoxes/TComboBox";
import TLabel from "../../../../Library/Labels/TLabel";
import TDialog from "../../../../Library/Dialogs/TDialog";

import { shouldComponentUpdateGB } from "../../../GB/NonComponents/GBUtil";

import * as DMConst from "../../NonComponents/DMConst";
import { getYearIdx } from "../../NonComponents/DMUtil";

class DMProgCovByAgeGroupForm extends React.Component {
    static propTypes = {
        navComboBoxHeight: PropTypes.number,
        results: PropTypes.object,
        selectedSNU_CurrID: PropTypes.number,
    };

    static defaultProps = {
        navComboBoxHeight: 35,
        results: {},
        selectedSNU_CurrID: 1,
    };

    constructor(props) {
        super(props);

        this.state = {
            finalYear: DMConst.lastYearProgData,
            showHelpDialog: false,
        };
    }

    /* Avoid re-rendering if we don't have to (if no props or state affect this form). */
    shouldComponentUpdate(nextProps, nextState) {
        return shouldComponentUpdateGB(this.props, nextProps, this.state, nextState);
    }

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onFinalYearComboBoxChange = (value, text, info) => {
        try {
            this.setState({
                finalYear: text,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    onHelpBtnClick = () => {
        try {
            this.setState({
                showHelpDialog: !this.state.showHelpDialog,
            });
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        try {
            const props = this.props;
            const results = props.results;
            const res = results[DMConst.rResult2];
            const inputs = results[DMConst.rInputs];
            const selectedSNU_CurrID = props.selectedSNU_CurrID;
            const navComboBoxHeight = props.navComboBoxHeight;

            const state = this.state;
            const finalYear = state.finalYear;
            const showHelpDialog = state.showHelpDialog;

            const pointLabels = res[DMConst.rPointLabels];
            const subsetLabels = res[DMConst.rSubsetLabels];
            const yAxisLabel = res[DMConst.rYAxisTitle];
            const data1 = res[DMConst.rData1];
            const SNU_Data = data1[selectedSNU_CurrID];

            const t1 = inputs[DMConst.rSurveyYearIdx] + 1;
            const t2 = getYearIdx(finalYear) + 1;

            /* xAxis point labels */
            let categories = [
                pointLabels[DMConst.DP_A10_14],
                pointLabels[DMConst.DP_A15_19],
                pointLabels[DMConst.DP_A20_24],
                pointLabels[DMConst.DP_A25_29],
                pointLabels[DMConst.DP_A30_34],
                pointLabels[DMConst.DP_A15_29],
                pointLabels[DMConst.DP_A10_29],
            ];

            /* Series names */
            let series = [
                {
                    name: subsetLabels[t1],
                    data: [],
                },

                {
                    name: subsetLabels[t2],
                    data: [],
                },
                {
                    name: "Difference in coverage between " + (DMConst.firstYear + t2 - 1 - 1) + " and baseline",
                    data: [],
                },
            ];

            series[0].data.push(SNU_Data[DMConst.DP_A10_14][t1]);
            series[1].data.push(SNU_Data[DMConst.DP_A10_14][t2]);
            series[2].data.push(SNU_Data[DMConst.DP_A10_14][t2] - SNU_Data[DMConst.DP_A10_14][t1]);

            series[0].data.push(SNU_Data[DMConst.DP_A15_19][t1]);
            series[1].data.push(SNU_Data[DMConst.DP_A15_19][t2]);
            series[2].data.push(SNU_Data[DMConst.DP_A15_19][t2] - SNU_Data[DMConst.DP_A15_19][t1]);

            series[0].data.push(SNU_Data[DMConst.DP_A20_24][t1]);
            series[1].data.push(SNU_Data[DMConst.DP_A20_24][t2]);
            series[2].data.push(SNU_Data[DMConst.DP_A20_24][t2] - SNU_Data[DMConst.DP_A20_24][t1]);

            series[0].data.push(SNU_Data[DMConst.DP_A25_29][t1]);
            series[1].data.push(SNU_Data[DMConst.DP_A25_29][t2]);
            series[2].data.push(SNU_Data[DMConst.DP_A25_29][t2] - SNU_Data[DMConst.DP_A25_29][t1]);

            series[0].data.push(SNU_Data[DMConst.DP_A30_34][t1]);
            series[1].data.push(SNU_Data[DMConst.DP_A30_34][t2]);
            series[2].data.push(SNU_Data[DMConst.DP_A30_34][t2] - SNU_Data[DMConst.DP_A30_34][t1]);

            series[0].data.push(SNU_Data[DMConst.DP_A15_29][t1]);
            series[1].data.push(SNU_Data[DMConst.DP_A15_29][t2]);
            series[2].data.push(SNU_Data[DMConst.DP_A15_29][t2] - SNU_Data[DMConst.DP_A15_29][t1]);

            series[0].data.push(SNU_Data[DMConst.DP_A10_29][t1]);
            series[1].data.push(SNU_Data[DMConst.DP_A10_29][t2]);
            series[2].data.push(SNU_Data[DMConst.DP_A10_29][t2] - SNU_Data[DMConst.DP_A10_29][t1]);

            const chartOptions = {
                chart: {
                    type: "column",
                },

                title: {
                    text: res.title,
                    x: -20,
                },

                xAxis: {
                    categories: categories,
                    labels: {
                        step: 1,
                        rotation: 90,
                    },
                    plotBands: [
                        {
                            from: 4.5,
                            to: 6.5,
                            color: "rgba(68, 170, 213, .2)",
                        },
                    ],
                },

                yAxis: {
                    title: {
                        text: yAxisLabel,
                    },
                    tickInterval: 5,
                    reversedStacks: false,
                    labels: {
                        format: "{value:,.0f} %",
                    },
                    min: 0,
                    max: 100,
                    plotLines: [
                        {
                            zIndex: 5,
                            color: "green", // Color value.
                            dashStyle: "solid", // Style of the plot line. Default to solid.
                            value: DMConst.coverageTarget, // Value of where the line will appear.
                            width: 2, // Width of the line.
                        },
                    ],
                },

                plotOptions: {
                    series: {
                        animation: false,
                    },
                },

                credits: {
                    text: "",
                },

                legend: {
                    layout: "horizontal",
                    align: "center",
                    verticalAlign: "top",
                    borderWidth: 0,
                    y: 20,
                },

                colors: Theme.DM_ChartColors,

                series: series,
            };

            const chart = (
                <GBStdChart
                    chartType={"column"}
                    id={DMConst.rResult2}
                    key={Date.now()}
                    options={chartOptions}
                    style={{
                        bottom: Theme.configDivStyle.height,
                        left: 0,
                        overflow: "hidden",
                        position: "absolute",
                        right: 0,
                        top: navComboBoxHeight,
                    }}
                />
            );

            const finalYearLabel = (
                <TLabel
                    caption={"End of"}
                    style={{
                        marginLeft: Theme.indent,
                    }}
                />
            );

            let year1DIntArray = [];

            for (let t = DMConst.firstYear; t <= DMConst.lastPossibleTargetYear - 1; t++) {
                year1DIntArray.push(t);
            }

            const finalYearComboBox = (
                <TComboBox
                    onChange={this.onFinalYearComboBoxChange}
                    itemIndex={finalYear - DMConst.firstYear}
                    items={year1DIntArray}
                    outerStyle={{
                        marginLeft: 5,
                        width: Theme.finalYearComboBoxWidth,
                    }}
                    style={Theme.finalYearComboBoxStyle}
                />
            );

            const helpBtn = (
                <div>
                    <img
                        alt="" // to avoid hint
                        onClick={this.onHelpBtnClick}
                        style={Theme.helpBtnImgStyle}
                        src={HelpIcon}
                    />
                </div>
            );

            const helpDialog = (
                <TDialog
                    caption={res.title}
                    content={
                        <div>
                            Male circumcision prevalence (%) by age group and SNU before the start of the VMMC program
                            compared to modeled MC coverage estimates at the beginning of a user-specified year. When
                            set to the current year, the MC coverage is a result of program achievements through the end
                            of the prior year. When set to future years, the MC coverage is a result of progress toward
                            user-specified coverage targets.
                        </div>
                    }
                    actions={["mrOK"]}
                    onClose={this.onHelpBtnClick}
                    style={{
                        width: 1000,
                    }}
                    maxWidth={"xl"}
                    visible={showHelpDialog}
                />
            );

            const configLeftDiv = (
                <div style={Theme.configLeftDivStyle}>
                    {finalYearLabel}
                    {finalYearComboBox}
                </div>
            );

            const configDiv = (
                <div style={Theme.configDivStyle}>
                    {configLeftDiv}
                    {helpBtn}
                </div>
            );

            const resultDiv = (
                <div
                    style={Theme.resultCenterDiv}
                    key={"resultDiv"}
                >
                    {chart}
                    {helpDialog}
                </div>
            );

            return (
                <div key={"DMProgCovByAgeGroupFormDiv"}>
                    {resultDiv}
                    {configDiv}
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"DMProgCovByAgeGroupFormDiv"}
                    key={"DMProgCovByAgeGroupFormDiv"}
                >
                    <h3 key={"DMProgCovByAgeGroupFormDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default DMProgCovByAgeGroupForm;
